// Unpublished Work © 2020-2024 Deere & Company.

import t from 'tcomb';

export const CustomerName = t.struct({
    businessName1: t.String,
    businessName2: t.String,
    doingBusinessAs: t.String,
    formattedName: t.String,
    familiarName: t.String,
    firstName: t.String,
    generation: t.String,
    generationId: t.String,
    lastName: t.String,
    middleName: t.String,
    prefix: t.String,
    prefixId: t.String,
    suffix: t.String,
    businessType: t.String,
    middleNameNotAvailableCheckSelected: t.Boolean
}, {
    defaultProps: {
        businessName1: '',
        businessName2: '',
        doingBusinessAs: '',
        formattedName: '',
        familiarName: '',
        firstName: '',
        generation: '',
        generationId: '',
        lastName: '',
        middleName: '',
        prefix: '',
        prefixId: '',
        suffix: '',
        businessType: '',
        middleNameNotAvailableCheckSelected: false
    },
    name: 'CustomerName'
});
